import * as React from 'react';
import cn from 'classnames';
import { clamp } from 'lodash-es';
import { controlClasses, ControlShapeType, ControlSizeType, Intent, intentClass } from '../../../library';
export var progressBarClasses = {
  MAIN: 'progress-bar',
  METER: 'progress-bar__meter'
};
export var ProgressBar = function ProgressBar(props) {
  var className = props.className,
    intent = props.intent,
    _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    shape = props.shape,
    size = props.size,
    isInverse = props.isInverse;
  var classNames = cn(progressBarClasses.MAIN, intentClass(intent), controlClasses({
    shape: shape,
    size: size
  }), {
    '-inverse': isInverse
  }, className);
  var width = value === null ? undefined : clamp(value, 0, 100) + '%';
  return React.createElement("div", {
    className: classNames
  }, React.createElement("div", {
    className: progressBarClasses.METER,
    style: {
      width: width,
      transitionDuration: "".concat(props.duration, "ms")
    }
  }));
};
ProgressBar.displayName = "ProgressBar";
ProgressBar.defaultProps = {
  isInverse: false,
  intent: Intent.NONE,
  size: ControlSizeType.MEDIUM,
  shape: ControlShapeType.ROUNDED
};